<div class="sub-nav-for-expanded" #host>
    <div class="sub-nav-for-expanded__inner">

        <div class="sub-nav-for-expanded__items">
            <ul class="sub-nav-for-expanded__list" #items>
                <ng-container *ngFor="let page of pages; trackBy: trackBy; let i = index">
                    <li #liElems class="sub-nav-for-expanded__li" id="sub-nav-{{registryId}}-{{page.Id}}"
                        (click)="onItemClick($event, page, i)" [ngClass]="{'is-active': activeId === page.Id}">
                        <label class="sub-nav-for-expanded__item-label" [attr.title]="page?.Name">{{page?.Name}}</label>
                        <shared-icon-btn size="xxs" class="sub-nav-for-expanded__item-icon" icon="next">
                        </shared-icon-btn>
                    </li>
                </ng-container>

                <shared-drop-down *ngIf="showMoreForDesktop" class="sub-nav-for-expanded__dropdown"
                    [options]="overflowPages" position="br" [selected]="selectedPage"
                    (onSelected)="handleDropDownSelected($event)">
                    <li class="sub-nav-for-expanded__li -for-more-desktop" id="sub-nav-expand-{{registryId}}">
                        <label class="sub-nav-for-expanded__item-label">More</label>
                        <shared-icon-btn [size]="iconSize" icon="burger-menu"
                            class="sub-nav-for-expanded__item-icon -for-expand">
                        </shared-icon-btn>
                    </li>
                </shared-drop-down>

                <li class="sub-nav-for-expanded__li -underline" #indicator></li>
            </ul>
        </div>

    </div>
</div>